<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12">
          <v-card :disabled="loading" :loading="loading">
            <v-card-text>
              <v-row>
                <v-col sm="6" md="3">
                  <v-select hide-details v-model="currentInterval" label="Interval" :items="intervalItems" outlined dense />
                </v-col>
                <v-col v-if="currentInterval == 'custom'"
                    sm="6" md="3"
                  >
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                      ref="menu"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="dateRangeText"
                          label="Select a date range"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          outlined
                          dense
                          hide-details
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dates"
                        range
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-autocomplete clearable v-model="filters.country_id" :items="countries" item-text="slug" item-value="id" outlined dense hide-details label="Country" />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-autocomplete clearable v-model="filters.status_id" :items="statuses" item-text="slug" item-value="id" outlined dense hide-details label="Status" />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-autocomplete clearable v-model="filters.user_id" :items="users" item-text="name" item-value="id" outlined dense hide-details label="User" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card elevation>
                    <v-card-text>
                      <apexchart v-if="series.length > 0" type="area" height="500" :options="chartOptions" :series="series"></apexchart>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <v-row justify="center">
                <v-col md="3" cols="6" v-for="item in stats">
                  <div class="text-center primary white--text pa-3 rounded">
                    <div style="text-transform: uppercase;" v-if="item.status.slug">{{i18n[item.status.slug]}}</div>
                    <div style="text-transform: uppercase;" v-if="item.country.slug">{{i18n[item.country.slug]}}</div>
                    <div style="text-transform: uppercase;">{{item.count}}</div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      filters: {
        user_id: null,
        country_id: null,
        status_id: null,
      },
      filter: null,
      loading: false,
      dates: [],
      stats: [],
      countries: [],
      users: [],
      statuses: [],
      menu: false,
      currentInterval: 'monthly',
      intervalItems: [
        {
          text: 'Monthly',
          value: 'monthly',
        },
        {
          text: 'Weekly',
          value: 'weekly',
        },
        {
          text: 'Yearly',
          value: 'yearly',
        },
        {
          text: 'Custom',
          value: 'custom',
        },
      ],
      series: [
      ],
      chartOptions: {
        chart: {
          height: 500,
          type: 'area'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          categories: []
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          },
        },
      },
    }
  },
  watch: {
    filters: {
      async handler(value) {
        let filter = ''

        Object.keys(value).map(_value => {
          if (this.filters[_value]) {
            filter += `&${_value}=${this.filters[_value]}`
          }
        })

        this.filter = filter

        await this.getStats()
      },
      deep: true,
      immediate: true
    },
    async currentInterval(value) {
      if (value != 'custom') {
        await this.getStats(value)
      }
      else {
        this.dates = []
      }
    },
    async dates(value) {
      if (value.length > 1) {
        await this.getStats('custom', value)
      }
    }
  },
  async created() {
    await this.getStats()
  },
  methods: {
    async getStats(interval = 'monthly', dates = []) {
      this.loading = true
      this.series = []
      
      let resource = `/lead-counters?interval=${interval}${this.filter}`

      if (dates.length > 0) {
        resource = `/lead-counters?interval=${interval}&start_date=${dates[0]}&end_date=${dates[1]}${this.filter}`
      }

      const {
        countries,
        users,
        statuses, 
        stats,
        data, 
        dates: _dates
      } = await this.$store.dispatch('getResource', { resource })

      console.log(users);
      
      this.stats = stats
      this.chartOptions.xaxis.categories = _dates
      this.series = data

      this.countries = countries 
      this.users = users 
      this.statuses = statuses 
      
      this.loading = false
    }
  },
  computed:{
    dateRangeText () {
      return this.dates.join(' ~ ')
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
}
</script>